export default function MembersHeader({
  count,
  exportLoading,
  exportExcel,
}) {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">

      <div>
        <h1 className="text-2xl font-bold">
          👥 Gestion des Membres
        </h1>

        <p className="text-gray-500 text-sm mt-1">
          {count} membres approuvés
        </p>
      </div>

      <button
        onClick={exportExcel}
        disabled={exportLoading}
        className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-xl font-semibold transition"
      >
        {exportLoading
          ? "⏳ Génération..."
          : "📥 Export Excel"}
      </button>

    </div>
  );
}